import { SM_PROGRAM_ID } from "@stadium/constants";

export const ORGANIZER_ORDER = "Spree::OrganizerOrder";

export const QUICK_RECOGNISE_KEY = "quick-recognise";
export const QUICK_RECOGNIZE_KEY = "quick-recognize";

export const MIN_CREDIT_CARD_CHARGE_AMOUNT = {
  USD: 1,
  PTS: 50,
};
export const POINTS_TO_USD_RATIO = 50;

export const MIN_REWARD_AMOUNT = 1;

/** Default points for organizer share / reward input until the user changes it */
export const DEFAULT_REWARD_AMOUNT = 1250;

export const RECOGNISE_RLP_MESSAGE_VIEW_LENGTH = 105;

export const DEFAULT_QUICK_RECOGNISE_PAYLOAD = {
  gift_detail_attributes: {},
  type: ORGANIZER_ORDER,
  quick_recognize: true,
  find_existing_quick_recognize_order: true,
  program_id: SM_PROGRAM_ID,
  eshop: true,
  redemption_method_slug: "",
};

export const DEFAULT_QUICK_RECOGNISE_PAYMENT = {
  use_global_point: false,
  credit_card_id: null,
  use_store_specific_point: false,
  use_wallet_money: false,
  use_team_point: false,
  team_id: null,
};

export const EXPRESS_REWARD = "express-reward";
export const SCRATCH_CARD_REWARD = "scratch-card";
export const SPIN_WHEEL_REWARD = "spin-wheel";
export const LUCKY_PICK_REWARD = "lucky-pick";

export const ANIMATION_DATA = {
  [EXPRESS_REWARD]: () => import("@stadium/ui/src/assets/animations/gifting-hand.json"),
  [SCRATCH_CARD_REWARD]: () => import("@stadium/ui/src/assets/animations/scratch-card.json"),
  [SPIN_WHEEL_REWARD]: () => import("@stadium/ui/src/assets/animations/spin-wheel.json"),
  [LUCKY_PICK_REWARD]: () => import("@stadium/ui/src/assets/animations/picknwin.json"),
};

export const RLP_TITLE_FORM_STATE = "header";
export const RLP_CONTENT_FORM_STATE = "content";
export const REWARD_FORMAT_FORM_STATE = "redemptionMethodSlug";
export const REWARD_AMOUNT_FORM_STATE = "rewardAmount";
export const BUDGET_FORM_STATE = "budget";
export const PAYMENT_METHOD_FORM_STATE = "paymentMethod";
export const RLP_STICKERS = "stickers";
export const RLP_IMAGES = "images";
